"use client"
// src/client/theme-setter.tsx
import { useEffect } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var ThemeSetter = ({
  isInitialTheme,
  variation
}) => {
  useEffect(() => {
    if (!variation || isInitialTheme) {
      document.body.setAttribute(
        "data-theme",
        document.querySelector(".module-wrapper")?.classList[0] || ""
      );
      return;
    }
    document.body.setAttribute("data-theme", variation);
  }, [isInitialTheme, variation]);
  return /* @__PURE__ */ jsx(Fragment, {});
};
var theme_setter_default = ThemeSetter;

export {
  theme_setter_default
};
